import { render, staticRenderFns } from "./V2BidButton.vue?vue&type=template&id=08b3eb13&scoped=true&"
import script from "./V2BidButton.vue?vue&type=script&lang=js&"
export * from "./V2BidButton.vue?vue&type=script&lang=js&"
import style0 from "./V2BidButton.vue?vue&type=style&index=0&id=08b3eb13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3eb13",
  null
  
)

export default component.exports